// extracted by mini-css-extract-plugin
export default {"preview":"VimeoPreview_preview__BZUeA"};